// @ts-nocheck
document.querySelectorAll('[data-section-reviews-grid]').forEach((section) => {
  section.querySelectorAll('[data-read-more]').forEach((btn) => {
    const textEl = document.getElementById(btn.getAttribute('aria-controls'));
    if (!textEl) return;

    if (textEl.scrollHeight > textEl.clientHeight + 2) {
      btn.style.display = 'flex';
    }

    btn.addEventListener('click', () => {
      const willExpand = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(willExpand));
      textEl.classList.toggle('is-expanded', willExpand);
      btn.querySelector('.section-reviews-grid__read-more-text').textContent = willExpand
        ? 'Read less'
        : 'Read more';
    });
  });
});
